import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import Table from 'rc-table';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { createStructuredSelector } from 'reselect';
import { BaseComponent } from '../../../components/BaseComponent';

import { ViesLabel } from './ViesLabel';
import { Button } from '../../../components/Buttons';
import { Loader } from '../../../components/Loader';
import { downloadViesCheckDocument } from '../actions';
import { selectWork } from '../../Api/selectors';
import { selectAddressTypes } from '../../Address/selectors';
import { REQUEST_DOWNLOAD_VIES_CHECK_DOCUMENT } from '../constants';
import { getDate } from '../../Vehicles/helpers';

const Container = styled.div`
  width: 100%;
  background: white;
`;

const CustomTable = styled(Table)`
  width: 100%;
  display: flex;
  font-size: 12px;

  .rc-table-container {
    width: 100%;
  }

  .rc-table-content table {
    width: 100%;
  }

  .rc-table-thead {
    background-color: #eff1f7;
    font-weight: 600;
    height: 52px;
    padding: 16px 0;
    margin-left: 8px;
    font-size: 14px;
  }

  td {
    border: 1px solid #ddd;
  }

  td,
  th {
    padding: 8px 12px;
  }
`;

/* eslint-disable react/prefer-stateless-function */
class ViesCheckHistoryTableComp extends BaseComponent {
  constructor(props) {
    super(props);
  }

  get historyLogs() {
    return this.props.historyLogs;
  }

  get homeAddressTypeId() {
    const addressTypeId = this.props.addressTypes.filter(t => t.name === 'home')[0]?.id;
    return addressTypeId;
  }

  getAddressValues(company, propertyName) {
    const homeAddress = company?.addresses?.filter(a => a?.typeId == this.homeAddressTypeId)[0];
    let value = '';
    switch (propertyName) {
      case 'country':
        value = homeAddress?.country?.name ?? '';
        break;
      default:
        value = homeAddress?.[propertyName] ?? '';
    }
    return value;
  }

  getData = item => {

    const check = item.valid;
    const date = getDate(item.requestDate);
    const download = {
      valid: item.valid,
      downloading: this.props.downloading,
    };

    return {
      check,
      date,
      download,
      item: item,
    };
  };

  getColumns = () => {
    return [
      {
        title: this.lblStr('company.details.vies.column.check'),
        dataIndex: 'check',
        key: 'check',
        align: 'left',
        render(value, row, index) {
          return <ViesLabel vies={value} />;
        },
      },
      {
        title: this.lblStr('company.details.vies.column.date'),
        dataIndex: 'date',
        key: 'date',
        align: 'left',
      },
      {
        title: this.lblStr('company.details.vies.column.download'),
        dataIndex: 'download',
        key: 'download',
        align: 'center',
        render(value, row, index) {
          return (
            <Button select disabled={!value.valid || value.downloading}>
              {value.downloading ? <Loader small /> : 'open'}
            </Button>
          );
        },
      },
    ];
  };

  render() {
    const columns = this.getColumns();
    const data = this.historyLogs?.map(item => {
      return this.getData(item);
    });
    return (
      <Container>
        <CustomTable
          columns={columns}
          data={data}
          scroll={{ x: window.innerWidth < 975 ? 975 : false }}
          emptyText={this.lbl('vehicles.overview.column.no_invoice_found')}
          onRow={(record, index) => {
            return {
              onClick: () => {
                this.props.download(record?.item, result => console.log(result, 'RESULT'));
              },
            };
          }}
        />
      </Container>
    );
  }
}

ViesCheckHistoryTableComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  onItemClick: PropTypes.func,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    addressTypes: selectAddressTypes(),
    downloading: selectWork(REQUEST_DOWNLOAD_VIES_CHECK_DOCUMENT),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    download(body, callback) {
      dispatch(
        downloadViesCheckDocument(body, result => {
          var blob = new Blob([new Uint8Array(result.file.data)], { type: 'application/pdf' });
          var objectUrl = URL.createObjectURL(blob);
          window.open(objectUrl);
        }),
      );
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const ViesCheckHistoryTable = compose(withConnect, withRouter, injectIntl)(ViesCheckHistoryTableComp);
